module.exports = __webpack_public_path__ + "fonts/SuisseIntl-BlackItalic.5d983f2.woff2";